// 12 real volunteer stories content and photos taken from the individual
// story pages on volunteering.org.au. All images are self-hosted.
const I = "/assets/img/";

export const STORIES = [
  {
    id: "nepal-dogs",
    kicker: "Stray Dog Rehabilitation",
    place: "Nepal",
    program: "Animal Rescue & Rehabilitation",
    volunteer: "Franziska",
    date: "Kathmandu · Kat Centre",
    accent: "Animals",
    cover: I + "2023-01-volunteer-with-dog-in-nepal-min-1.webp",
    gallery: [I + "story-nepal-animal-rescue.jpg"],
    lead:
      "This was by far the most valuable experience. The people at the Kat Centre are the best, they are doing such an amazing job and were really welcoming and appreciative of my work there.",
    body: [
      "But the most fulfilling was to see the dogs change and looking forward to me taking them for a walk every day.",
    ],
    facts: [
      "Around 25% of the population in Nepal are living below the poverty line.",
      "Malnutrition is particularly evident in children under 5, with 36% enduring stunting.",
      "Children from poor families have low attendance at school, with 1 in 4 of the poorest not going to school at all.",
      "Nepal can experience natural disasters, such as earthquakes, which severely impact local structures and roads.",
      "Much of Nepal's population lacks access to basic medical care.",
    ],
    source: "/projects/nepal/stray-dog-rehabilitation/",
  },
  {
    id: "koh-samui-elephants",
    kicker: "Elephant Conservation",
    place: "Koh Samui, Thailand",
    program: "Elephant Care",
    volunteer: "Stephanie",
    date: "January 2026",
    accent: "Wildlife",
    cover: I + "2025-03-Koh-Samui-Elephant-Care-Program-16-600x800.jpg",
    gallery: [],
    lead:
      "The volunteer program was absolutely amazing. We were guided patiently on how to take care of the elephants.",
    body: [
      "Everyone there was extremely friendly. This experience is definitely once in a life time.",
    ],
    facts: [],
    source: "/review-elephant-conservation-koh-samui/",
  },
  {
    id: "cheetah-south-africa",
    kicker: "Cheetah Conservation",
    place: "Cape Town, South Africa",
    program: "Ashia Cheetah Sanctuary",
    volunteer: "Carl",
    date: "August 2025",
    accent: "Wildlife",
    cover: I + "2025-05-Cheetah-feeding.jpg",
    gallery: [I + "2025-05-Cheetah-relax-600x800.jpg"],
    lead:
      "At Ashia, I supported a loving team with daily tasks such as keeping the enclosures clean, shredding antelopes and feeding the kittens.",
    body: ["Nice and clean accommodation, fresh lunch during the week and a helpful, lovely team."],
    facts: [],
    source: "/cheetah-conservation-review-south-africa/",
  },
  {
    id: "peru-teaching",
    kicker: "Teaching English",
    place: "Cusco, Peru",
    program: "English Teaching",
    volunteer: "Solange",
    date: "May 2025",
    accent: "Teaching",
    cover: I + "2025-05-p1-2-555x1024.jpg",
    gallery: [
      I + "2025-05-p2-2-576x1024.jpg",
      I + "2025-05-p3-2-576x1024.jpg",
      I + "2025-05-p5-2-600x800.jpg",
    ],
    lead:
      "Cusco is much bigger than I thought. It's a great city full of colours, culture and folklore. People are very friendly.",
    body: [
      "First of all, I took the HOP HOP BUS to get from Lima to Cusco and it was the best thing to do! I travelled the south for 8 days and discovered wonderful places: Paracas, Huacachina, Nazca, Arequipa, Puno…",
      "I was volunteering 400 metres higher than Cusco, and it was quite cold up there (3,800 metres). I had a wonderful time with the lovely children and Rogelio, founder of the school, was such a nice man!",
      "The local team was very kind, available and helpful. The Spanish courses were a big '+'. Food was delicious: being vegetarian, I was so happy to have all these incredible vegetables and fruits in so many veggie restaurants.",
    ],
    facts: [],
    source: "/teaching-in-peru-review-2/",
  },
  {
    id: "nusa-penida-turtles",
    kicker: "Turtle Conservation",
    place: "Nusa Penida, Indonesia",
    program: "Turtle Conservation",
    volunteer: "Eliza",
    date: "April 2025",
    accent: "Conservation",
    cover: I + "2024-11-beach-clean.jpg",
    gallery: [I + "2024-10-turtles-in-tank-600x800.jpg"],
    lead:
      "I volunteered in Indonesia. I did their turtle conservation project in Nusa Penida. I loved how friendly the people were that also volunteered.",
    body: [
      "Everything was very neat. The rooms were good, the food was fine and the local team was really kind.",
    ],
    facts: [],
    source: "/turtle-conservation-nusa-penida-review/",
  },
  {
    id: "vietnam-road-trip",
    kicker: "3 Week Road Trip",
    place: "Vietnam",
    program: "Soup Kitchen & 21-Day Road Trip",
    volunteer: "Robert & Bernadette",
    date: "January 2025",
    accent: "Community",
    cover: I + "2025-01-cooking.jpg",
    gallery: [I + "2025-01-with-coordinator-.jpg", I + "2025-01-floating-on-the-mekong-rotated.jpg"],
    lead:
      "The local team organised it very well. Everything went smoothly. It was great to meet other volunteers involved in other projects. We became aware that we were the first to experience the road trip part of the project.",
    body: [
      "It was a bonus to explore more of Vietnam with someone from the area. She also had an opportunity to visit her family. The sleeper buses must be experienced!",
      "We wish we could have participated for two weeks; five days was far too short. The dedicated team at the kitchen was wonderful to work with, and the local team support ensured we were okay.",
      "Local team members had key roles, executed with a high level of professionalism and care. A social event was held on Monday nights so new volunteers could meet others.",
    ],
    facts: [],
    source: "/3-week-road-trip-in-vietnam-review/",
  },
  {
    id: "bali-turtles-maitreyi",
    kicker: "Bali Turtles Program",
    place: "Bali, Indonesia",
    program: "Turtle Conservation",
    volunteer: "Maitreyi",
    date: "May 2024",
    accent: "Conservation",
    cover: I + "2024-01-holding-turtles.jpeg",
    gallery: [I + "2024-01-holding-turtle-600x800.jpeg"],
    lead:
      "Volunteering was the best experience of my life! The turtles are so cute and it was very fulfilling to take care of them.",
    body: [
      "I met loads of amazing people, visited places that looked absolutely out of this world, and gained lots of independence. I feel as though this experience has changed me as a person, I've learnt a lot.",
      "The coordinators are amazing: they're easygoing, funny, dedicated and always there to make you smile. The food and the accommodation was excellent.",
    ],
    facts: [],
    source: "/bali-turtles-program-review/",
  },
  {
    id: "fiji-animals-paige",
    kicker: "Fiji Animals",
    place: "Fiji",
    program: "Animal Shelter & Clinic",
    volunteer: "Paige",
    date: "October 2023",
    accent: "Animals",
    cover: I + "2023-10-puppies-1-1024x768.webp",
    gallery: [I + "2023-10-puppy-1-min-2-768x1024.webp"],
    lead:
      "I loved getting to know the locals and experiencing what it's like in a shelter and clinic in Fiji.",
    body: ["Food was great. Great to try more traditional meals."],
    facts: [],
    source: "/fiji-animals-review/",
  },
  {
    id: "fiji-shelter-steph",
    kicker: "Animal Shelter Review",
    place: "Fiji",
    program: "Animals Fiji",
    volunteer: "Steph",
    date: "July 2023",
    accent: "Animals",
    cover: I + "2023-07-fiji-1-scaled-min-1-768x1024.webp",
    gallery: [],
    lead:
      "Volunteering was excellent, I got to experience what it was like to be working with animals in Fiji.",
    body: [
      "I had conversations with locals which gave me great insight into religious and cultural beliefs which impact animal control.",
      "Being immersed in local culture was fantastic and gave an experience which I would not have had the chance to outside of this project. Our home stay was lovely, always willing to help out and teach us about the local culture.",
    ],
    facts: [],
    source: "/animal-shelter-review-in-fiji/",
  },
  {
    id: "bali-turtle-valentine",
    kicker: "Bali Turtle Conservation",
    place: "Bali, Indonesia",
    program: "Turtle Conservation",
    volunteer: "Valentine",
    date: "July 2023",
    accent: "Conservation",
    cover: I + "2023-07-turtles-min-1-881x1024.webp",
    gallery: [
      I + "2023-07-holding-turtle-bali-min-1-768x1024.webp",
      I + "2023-07-62F9141C-3FC6-4731-A1F6-804D939A7Af91-min-1-600x800.webp",
    ],
    lead:
      "It was just amazing the coordinators and the centre were perfect. We had lots of information about turtles and it was perfect for helping turtle life.",
    body: ["Local team, perfect!!! Food good and accommodation too. Nothing to improve thank you!"],
    facts: [],
    source: "/bali-turtle-conservation-review/",
  },
  {
    id: "ubud-kindergarten",
    kicker: "Kindergarten in Ubud",
    place: "Ubud, Bali",
    program: "Kindergarten Teaching",
    volunteer: "Larissa",
    date: "June 2023",
    accent: "Teaching",
    cover: I + "2023-06-06216910-31CD-49A3-A7B2-CC4A093D750A-1-min-1-1024x768.webp",
    gallery: [I + "2023-01-Lov_Teaching-1-min-1-600x800.webp"],
    lead: "My volunteering experience in Bali was truly amazing!",
    body: [
      "The introduction week was great we visited temples, Ubud, a traditional dance show, made batik painting and much more and after that my project in the kindergarten started.",
      "The kids are 5-6 years old and don't know much English, so you teach them the basics very playfully. Working in the kindergarten can be very loud, but overall it's fun and the kids are so sweet and thankful!",
      "In the afternoon you can chill at the pool or make day trips to waterfalls, go out for dinner in Ubud or even go to the beach. On the weekends nearly nobody stays in the accommodation everyone goes on trips to discover more of Bali.",
      "The local team is so sweet and very helpful. I had a surf accident and they really took care of me. The food was very traditional Indonesian food but soo good, with fresh fruit at every meal.",
    ],
    facts: [],
    source: "/review-of-kindergarten-project-in-ubud/",
  },
  {
    id: "fiji-shelter-project",
    kicker: "Animal Shelter in Fiji",
    place: "Fiji",
    program: "Animal Shelter Project",
    volunteer: "IVI Volunteer",
    date: "2023",
    accent: "Animals",
    cover: I + "2023-07-fiji-1-scaled-min-1-600x800.webp",
    gallery: [],
    lead:
      "Working alongside the shelter team in Fiji, caring for rescued dogs and supporting the outreach clinics that keep the island's animals healthy.",
    body: [
      "Days are spent feeding, walking and socialising rescued animals, assisting the vet team and helping educate the local community about animal welfare.",
    ],
    facts: [],
    source: "/animal-shelter-in-fiji-review-of-project/",
  },
];

export const STORY_FILTERS = ["All stories", "Wildlife", "Animals", "Conservation", "Teaching", "Community"];
